import React, { ReactNode } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import NavBar from '../NavBar';
import Svg from '../Svg';
import Icon from '../Icon';
import IconButton from '../IconButton';
import Dropdown from '../Dropdown';
import HeaderPatientInfo from '../HeaderPatientInfo';
import { PatientInfoVisibility } from '../../types/PatientInfoVisibility';



function Header({
  children,
  menuOptions,
  isReturnEnabled = true,
  onClickReturnButton,
  isSticky = false,
  WhiteLabeling,
  showPatientInfo = PatientInfoVisibility.VISIBLE_COLLAPSED,
  servicesManager,
  Secondary,
  appConfig,
  ...props
}: withAppTypes): ReactNode {
  const { t } = useTranslation('Header');

  // TODO: this should be passed in as a prop instead and the react-router-dom
  // dependency should be dropped
  const onClickReturn = () => {
    if (isReturnEnabled && onClickReturnButton) {
      onClickReturnButton();
    }
  };
  // VISUALIZADOR DE LA CABECERA
  return (
    <NavBar
      className="justify-between border-b-4 border-gray-windows bg-gray-windows navbar-espacio css-header" 
      isSticky={isSticky}
    >
      <div className="flex justify-between flex-1 items-center navbar-espacio">
        {/*Div de LOGO*/}
        <div className="flex items-center navbar-logo">
          <div
            className={classNames(
              'inline-flex items-center mr-3',
              isReturnEnabled && 'cursor-pointer'
            )}
            onClick={onClickReturn}
          >
            {isReturnEnabled && (
              <Icon name="chevron-left" className="w-8 text-primary-active" />
            )}
            <div className="ml-4">
              {WhiteLabeling?.createLogoComponentFn?.(React, props) || (
                <a href="https://Med-it.app" target={'_blank'}>
                  <Svg name="logo-pacs" />
                </a>
              )}
            </div>
          </div>
        </div>
        {/*Div de barra de herramientas*/}
        <div className="absolute top-1/2 left-[250px] h-8 -translate-y-1/2">{Secondary}</div>
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform navbar-herramientas">
          <div className="flex items-center justify-center space-x-2">{children}</div>
        </div>
        {/*Div de Usuario y Configuracion*/}
        <div className="absolute right-0 top-1/2 flex -translate-y-1/2 select-none items-center navbar-usuario">
          {showPatientInfo !== PatientInfoVisibility.DISABLED && (
            <HeaderPatientInfo
              servicesManager={servicesManager}
              appConfig={appConfig}
            />
          )}
          <div className="border-primary-dark mx-1.5 h-[25px] border-r"></div>
          <div className="flex-shrink-0">
            <Dropdown
              id="options"
              showDropdownIcon={false}
              list={menuOptions}
              alignment="right"
            >
              <IconButton
                id={'options-settings-icon'}
                variant="text"
                color="inherit"
                size="initial"
                className="text-primary-active hover:bg-primary-dark h-full w-full"
              >
                <Icon name="icon-settings" />
              </IconButton>
            </Dropdown>
          </div>
        </div>
      </div>

      {/* Estilos Responsivos para Ajuste Adicional */}
      <style jsx global>{`
        @media (max-width: 768px) {
          .navbar-logo {
            position: absolute;
            top: 0;
            left: 0;
            padding-top: 10px;
          }
          .navbar-espacio {
            padding-top: 100px;
          }
          .navbar-usuario {
            position: absolute;
            top: 0;
            right: 0;
            padding-top: 70px;
          }
          .navbar-herramientas {
            position: relative;
            top: 1px;
          }
        }
      `}</style>
    </NavBar>
  );

  //CODIGO VIEJO - PREDETERMINADO
  /*<NavBar
    isSticky={isSticky}
    {...props}
  >
    <div className="relative h-[48px] items-center ">
      <div className="absolute left-0 top-1/2 flex -translate-y-1/2 items-center">
        <div
          className={classNames(
            'mr-3 inline-flex items-center',
            isReturnEnabled && 'cursor-pointer'
          )}
          onClick={onClickReturn}
          data-cy="return-to-work-list"
        >
          {isReturnEnabled && (
            <Icon
              name="chevron-left"
              className="text-primary-active w-8"
            />
          )}
          <div className="ml-1">                                               
            {WhiteLabeling?.createLogoComponentFn?.(React, props) || <Svg name="logo-pacs" style={{ padding: '5px' }}/>} 
          </div>
        </div>
      </div>
      <div className="absolute top-1/2 left-[250px]  h-8 -translate-y-1/2">{Secondary}</div>
      <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform">
        <div className="flex items-center justify-center space-x-2">{children}</div>
      </div>
      <div className="absolute right-0 top-1/2 flex -translate-y-1/2 select-none items-center">
        {showPatientInfo !== PatientInfoVisibility.DISABLED && (
          <HeaderPatientInfo
            servicesManager={servicesManager}
            appConfig={appConfig}
          />
        )}
        <div className="border-primary-dark mx-1.5 h-[25px] border-r"></div>
        <div className="flex-shrink-0">
          <Dropdown
            id="options"
            showDropdownIcon={false}
            list={menuOptions}
            alignment="right"
          >
            <IconButton
              id={'options-settings-icon'}
              variant="text"
              color="inherit"
              size="initial"
              className="text-primary-active hover:bg-primary-dark h-full w-full"
            >
              <Icon name="icon-settings" />
            </IconButton>
          </Dropdown>
        </div>
      </div>
    </div>
  </NavBar>*/

}

Header.propTypes = {
  menuOptions: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      icon: PropTypes.string,
      onClick: PropTypes.func.isRequired,
    })
  ),
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
  isReturnEnabled: PropTypes.bool,
  isSticky: PropTypes.bool,
  onClickReturnButton: PropTypes.func,
  WhiteLabeling: PropTypes.object,
  showPatientInfo: PropTypes.string,
  servicesManager: PropTypes.object,
};

//nuevo
Header.defaultProps = {
  isReturnEnabled: true,
  isSticky: false,
};
export default Header;
